import type { EcommerceProductDetails } from '../../../../../types/analytics/ECommerce';
import type { BaseProductDetails } from '../../../../../types/CoreShoppingExperience';

const convertToProductDetails = (productDetails: BaseProductDetails): EcommerceProductDetails => {
  return {
    departureDateTime: productDetails.departureDateTime,
    arrivalDateTime: productDetails.arrivalDateTime,
    originCode: productDetails.originCode,
    originName: productDetails.originName,
    destinationCode: productDetails.destinationCode,
    destinationName: productDetails.destinationName,
    duration: productDetails.durationInMinutes,
    operatingCarrier: productDetails.operatingCarrier,
    marketingCarrier: productDetails.marketingCarrier,
    operatingFlightNumber: productDetails.operatingProductNumber,
    marketingFlightNumber: productDetails.marketingProductNumber,
    equipment: productDetails.equipment,
  };
};

export default convertToProductDetails;
